import axios from './axios';

export default class AuthService {
  static signIn(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/msi/individual/auth', payload);
  }

  static getOtpCode(phone_number) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/notification/sms/otp', { phone_number });
  }

  static getAuthorizedOtpCode() {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/notification/sms/otp');
  }

  static getProfile() {
    return axios.get(window.entityCabinetSettings.openApi.url + '/api/msi/individual/profile');
  }
  static refreshToken() {
    const token = localStorage.getItem('token');

    return fetch(window.entityCabinetSettings.openApi.url + '/api/session/refresh-token', {
      method: 'get',
      headers: new Headers({
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    });
  }
}